export default "__VITE_ASSET__bfa2c98c__"